import actions from './actions';
import initialState from '../initialState';

export const experiencesReducer = (state = initialState.experiences, action) => {
    switch (action.type) {
        case actions.NONBFI_DETAIL_MODAL:
            return {
                ...state,
                nonBfiDetailModal: action.state.nonBfiDetailModal,
            };
        case actions.BFI_DETAIL_MODAL:
            return { ...state, bfiDetailModal: action.state.bfiDetailModal };
        case actions.AUDIT_HISTORY_MODAL:
            return {
                ...state,
                auditHistoryModal: action.state.auditHistoryModal,
            };
        default:
            return { ...state };
    }
};

export default experiencesReducer;
